import { useState } from "react";
import NavItem from "./NavItem";
import "./nav.css";
import ToggleSlide from "../../icons/ToggleSlide";

const navItems = [
  { icon: "dashboard", hlink: "/dashboard", title: "Dashboard" },
  { icon: "receipt_long", hlink: "/Requests", title: "Requests" },
  { icon: "groups", hlink: "/Attendants", title: "Attendants" },
  { icon: "error", hlink: "/Decliends", title: "Declined" },
  { icon: "logout", hlink: "/logout", title: "Log out" },
];

const SideBar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <aside
      className="sidenav navbar navbar-vertical navbar-expand-xs border-0 m-0 sidebar-shell"
      id="sidenav-main"
      style={{
        height: "100vh",
        maxHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        transition: "width 0.25s ease",
        width: isCollapsed ? "82px" : "240px",
      }}
    >
      <div className="sidenav-header d-flex justify-content-center align-items-center py-3">
        <button
          type="button"
          onClick={() => setIsCollapsed((prev) => !prev)}
          className="btn btn-link text-white p-0 border-0 sidebar-toggle"
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <ToggleSlide isOpen={isCollapsed} />
        </button>
      </div>

      <div className="px-3 pb-3">
        <div className="sidebar-brand">
          <div className="sidebar-brand__icon">A</div>
          {!isCollapsed && <span className="sidebar-brand__name">Al-Aliaa</span>}
        </div>
      </div>

      <hr className="horizontal light my-0 mx-3" style={{ opacity: 0.22, borderColor: "rgba(255,255,255,0.3)" }} />

      <div className="w-auto" id="sidenav-collapse-main">
        <ul className="navbar-nav px-2 py-2 gap-1">
          {navItems.map((item) => (
            <NavItem
              key={item.hlink}
              icon={item.icon}
              hlink={item.hlink}
              title={isCollapsed ? "" : item.title}
            />
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default SideBar;
